import React, { useMemo } from "react";
import { formatTimeAgo } from "../../../Utils/helper";
import { StatusEnum } from "../../../Utils/enum";

const getStatusColor = (status) => {
  switch (status) {
    case "QUEST_APPROVED":
    case "WITHDRAW_SUCCESSFUL":
      return "text-[#253FF6]";
    case "QUEST_REJECTED":
    case "WITHDRAW_UNSUCCESSFUL":
      return "text-[#EF4056]";
    case "TIMEOUT":
      return "text-[#EF4056]";
    default:
      return "text-gray-700";
  }
};

const getStatusMessage = (status) => {
  return StatusEnum[status] || status;
};

const InboxCard = ({
  status,
  title,
  message,
  linkText = "Contact us",
  linkHref,
  timestamp,
}) => {
  const titleParts = useMemo(() => {
    if (!title || !title.includes("Contact us")) {
      return { hasLink: false, beforeLink: title, afterLink: "" };
    }
    const parts = title.split("Contact us");
    return {
      beforeLink: parts[0].trim(),
      afterLink: parts[1]?.trim() || "",
      hasLink: true,
    };
  }, [title]);

  return (
    <div className="max-w-xl mx-auto bg-white rounded">
      <div className="border-b pb-4">
        <h3 className={`font-medium text-lg mb-1 ${getStatusColor(status)}`}>
          {getStatusMessage(status)}
        </h3>
        {title && (
          <p className="text-[#333333] text-sm font-medium mb-1">
            {titleParts.beforeLink}
            {titleParts.hasLink && (
              <>
                {" "}
                <a
                  href={linkHref}
                  className="text-[#333] border-b border-[#333] cursor-pointer"
                >
                  {linkText}
                </a>
                {titleParts.afterLink && ` ${titleParts.afterLink}`}
              </>
            )}
          </p>
        )}
        {message && (
          <p className="text-gray-700 text-sm">
            {message}
            {linkText && linkHref && !titleParts.hasLink && (
              <>
                {" "}
                <a
                  href={linkHref}
                  className="text-[#333] border-b border-[#333] cursor-pointer"
                >
                  {linkText}
                </a>
              </>
            )}
          </p>
        )}
        <div className="flex justify-start items-end">
          <p className="text-[#A0A0A0] font-medium text-xs mt-2">
            {formatTimeAgo(timestamp)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InboxCard;
